import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../../../utilities/TabGrid";
import TabUtilities from "../../../../../../utilities/TabUtilities";


export default class RodzajeKalendarzyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell,row){
        if(row.blokada!==1)
            return(
                <div>
                    <TopButtonPointEdit onClick={()=>{this.props.handleEdytuj(row)}} titleContent={'Edytuj kalendarz'} />
                    <TopButtonPointRemove onClick={()=>{this.props.handleUsun(row)}} titleContent={'Usuń kalendarz'} />
                </div>
            )
        else return''
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idRk' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazRk'
                                       thStyle={tabgrid.tg22} tdStyle={tabgrid.tg22}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa kalendarza</TableHeaderColumn>
                    <TableHeaderColumn dataField='idRk'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/rodzajeKalendarzy/components/RodzajeKalendarzyTable.js